import { z } from 'zod';

// CSP production có `require-trusted-types-for 'script'` và không cho 'unsafe-eval': tắt JIT của zod
// (vốn thử `new Function` để biên dịch schema) để không phát sinh vi phạm CSP mỗi lần kiểm dữ liệu.
z.config({ jitless: true });
